import { useState, useEffect } from "react";
import { IoMdInformationCircle } from "react-icons/io";
import "../dashboardstyle.css";
import { Info } from "lucide-react";

export default function Companysettings() {
  //state ob die KI alle eingehenden bewerbungen mit bereits eingesendeten bewerber vergleichen soll die angenommen wurden
  const [compare, setCompare] = useState(false);
  //state für ausklappen von info text
  const [infoBewerberVergleich, setInfoBewerberVergleich] = useState(false);
  //ob hirehero automatisch emails senden soll
  const [autoSend, setAutoSend] = useState(false);
  const [infoAutoSend, setInfoAutoSend] = useState(false);

  return (
    <div>
      <h2 style={{ fontFamily: "'Syne', sans-serif", marginBottom: 24 }}>
        Einstellungen
      </h2>

      <div
        style={{
          background: "rgba(255,255,255,0.03)",
          border: "1px solid rgba(255,255,255,0.07)",
          borderRadius: 12,
          overflow: "hidden",
        }}
      >
        {/* KI vergleicht Bewerber */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 20px",
            borderBottom: infoBewerberVergleich
              ? "none"
              : "1px solid rgba(255,255,255,0.05)",
          }}
        >
          <div>
            <p style={{ color: "#f0f0f0", fontSize: "0.9rem", margin: 0 }}>
              KI vergleicht Bewerber
            </p>
            <p
              style={{
                color: "rgba(255,255,255,0.35)",
                fontSize: "0.78rem",
                margin: "3px 0 0 0",
              }}
            >
              Eingehende Bewerbungen werden verglichen
            </p>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span
              onClick={() => setInfoBewerberVergleich(!infoBewerberVergleich)}
              style={{ cursor: "pointer", color: "rgba(255,255,255,0.3)" }}
            >
              <Info size={16} />
            </span>
            <label className="toggle">
              <input
                type="checkbox"
                checked={compare}
                onChange={() => setCompare(!compare)}
              />
              <span className="toggle-slider" />
            </label>
          </div>
        </div>

        {infoBewerberVergleich && (
          <div
            style={{
              padding: "12px 20px 16px",
              borderBottom: "1px solid rgba(255,255,255,0.05)",
              background: "rgba(255,255,255,0.02)",
            }}
          >
            <p
              style={{
                color: "rgba(255,255,255,0.4)",
                fontSize: "0.82rem",
                margin: 0,
                lineHeight: 1.6,
              }}
            >
              HireHero KI soll eingehende Bewerbungen immer mit anderen
              vorhandenen Bewerbungen vergleichen die bereits angenommen wurden
              oder auf eine manuelle Prüfung warten.
            </p>
          </div>
        )}

        {/* KI vergleicht Bewerber */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px 20px",
            borderBottom: infoBewerberVergleich
              ? "none"
              : "1px solid rgba(255,255,255,0.05)",
          }}
        >
          <div>
            <p style={{ color: "#f0f0f0", fontSize: "0.9rem", margin: 0 }}>
              HireHero soll automatisch einladung & ablehungen versenden
            </p>
            <p
              style={{
                color: "rgba(255,255,255,0.35)",
                fontSize: "0.78rem",
                margin: "3px 0 0 0",
              }}
            >
              Auto send
            </p>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <span
              onClick={() => setInfoAutoSend(!infoAutoSend)}
              style={{ cursor: "pointer", color: "rgba(255,255,255,0.3)" }}
            >
              <Info size={16} />
            </span>
            <label className="toggle">
              <input
                type="checkbox"
                checked={autoSend}
                onChange={() => setAutoSend(!autoSend)}
              />
              <span className="toggle-slider" />
            </label>
          </div>
        </div>

        {infoAutoSend && (
          <div
            style={{
              padding: "12px 20px 16px",
              borderBottom: "1px solid rgba(255,255,255,0.05)",
              background: "rgba(255,255,255,0.02)",
            }}
          >
            <p
              style={{
                color: "rgba(255,255,255,0.4)",
                fontSize: "0.82rem",
                margin: 0,
                lineHeight: 1.6,
              }}
            >
              HireHero wird an Bewerber automatisch Einladungen & Ablehnungen
              verschicken. Wenn ausgeschaltet, wird eine Bestätigung benötigt
              für das senden von Einladungen oder Ablehnungen.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
